import React from 'react';
import { motion } from 'framer-motion';
import { Search, Clock, BrainCircuit } from 'lucide-react';
export function Slide02Problem() {
  const findings = [{
    icon: Clock,
    stat: '42 mins',
    text: 'Average time users spend weekly browsing and selecting meals.'
  }, {
    icon: BrainCircuit,
    stat: '68%',
    text: "Report 'decision fatigue' when trying to balance macros, budget, and taste."
  }, {
    icon: Search,
    stat: '3.2x',
    text: 'Higher churn rate for users who skip a week due to forgetting to pick meals.'
  }];
  return <div className="w-full h-full flex flex-col justify-center px-[clamp(4rem,8vw,10rem)] bg-[var(--fg)] text-[var(--bg)]" data-id="element-58">
      <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} className="mb-16" data-id="element-59">
        <div className="flex items-center gap-4 mb-6" data-id="element-60">
          <div className="h-px w-12 bg-[var(--accent)]" data-id="element-61" />
          <span className="text-[var(--accent)] font-semibold tracking-widest uppercase text-sm" data-id="element-62">
            User Research Findings
          </span>
        </div>
        <h2 className="font-display text-[clamp(3rem,4.5vw,5rem)] leading-[1.1] max-w-5xl text-[var(--bg)]" data-id="element-63">
          Choosing meals is becoming a chore, not a joy.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-[clamp(2rem,4vw,4rem)]" data-id="element-64">
        {findings.map((item, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2 + i * 0.15,
        type: 'spring',
        stiffness: 200,
        damping: 20
      }} className="group" data-id="element-65">
            <div className="w-14 h-14 bg-[var(--bg)]/10 rounded-2xl flex items-center justify-center text-[var(--accent)] mb-8 group-hover:scale-110 transition-transform duration-300" data-id="element-66">
              <item.icon size={28} strokeWidth={1.5} data-id="element-67" />
            </div>
            <div className="font-display text-[clamp(2.5rem,3.5vw,3.5rem)] mb-4 text-[var(--bg)]" data-id="element-68">
              {item.stat}
            </div>
            <p className="text-[var(--bg)]/70 leading-relaxed text-lg font-medium pr-4" data-id="element-69">
              {item.text}
            </p>
          </motion.div>)}
      </div>
    </div>;
}